import Repository from './Repository'

const resource = '/users'

export default {
  async get () {
    try {
      return await Repository.get(`${resource}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getInfo () {
    try {
      return await Repository.get(`${resource}`, {}, {}, true)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getByWorkerSid (worker_sid, isSilent = false) {
    try {
      return await Repository.get(`${resource}/worker-sid/${worker_sid}`, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getListUsersByWorkerSids (data, reload = false) {
    try {
      return await Repository.post(`${resource}/worker-sids`, data, {}, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async login (data) {
    try {
      return await Repository.post(`${resource}/login`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async refreshTwilioToken () {
    try {
      return await Repository.get(`${resource}/twilio/token`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async create (data) {
    try {
      return await Repository.post(`${resource}/create`, data.formData, data.configHeader)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async getList (param, isSilent = false) {
    try {
      return await Repository.get(`${resource}/list-agent`, param, {}, isSilent)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async delete (id) {
    try {
      return await Repository.delete(`${resource}/delete-agent/${id}`)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async forgotPassword (data) {
    try {
      return await Repository.post(`${resource}/forgot-password`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async resetPassword (data) {
    try {
      return await Repository.post(`${resource}/confirm-forgot-password`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async changePassword (data) {
    try {
      return await Repository.post(`${resource}/change-password`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async update (data) {
    try {
      return await Repository.post(`${resource}/update-info`, data.formData, data.configHeader)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async updateSelf (data) {
    try {
      return await Repository.post(`${resource}/update-self-info`, data.formData, data.configHeader)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async checkToken (data) {
    try {
      return await Repository.post(`${resource}/check-token-forgot-password`, data)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async setPhoneNumber (twilioPhoneId) {
    try {
      return await Repository.post(`${resource}/update-twilio-phone/${twilioPhoneId}`)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async setAvatarDefault (data) {
    try {
      return await Repository.post(`${resource}/set-avatar-default`, data)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async refreshToken (data) {
    try {
      return await Repository.post(`${resource}/refresh-token`, data)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async updateIsMustLogoutStatus (userId, isSilent = false) {
    try {
      return await Repository.post(`${resource}/logout/${userId}`, {}, {}, {}, isSilent)
    } catch (e) {
      return this.catchError(e)
    }
  },
  async updateUserAdditionalInfo (data) {
    try {
      return await Repository.patch(`${resource}/update/user-additional-info`, data)
    } catch (e) {
      return this.catchError(e)
    }
  },

  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
